export default function CopyToClipboardButton({ toCopy, label }) {
    return (
        <button
            type='button'
            className='p-0 text-blue-600 bg-transparent border-none hover:text-blue-800'
            title={`Copy ${label}`}
            aria-label={`Copy ${label}`}
            onClick={(event) => {
                event.stopPropagation();
                navigator.clipboard.writeText(toCopy);
            }}
        >
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'>
                <path
                    fillRule='evenodd'
                    d='M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z'
                />
            </svg>
        </button>
    );
}
